import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/damian-albrycht.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/hero-onas.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/kasia-bochenek.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/krzysztof.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/story.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/values-img.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/src/components/animation/AnimateBoxSlideDown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/components/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardContainer","CardBody","CardItem"] */ "/Users/dawid/Work/aw-sport/src/components/ui/3d-trainer-card.tsx");
